import { $Locale, $RootTraffic } from '@lemon8/web-app-shared/atom';
import { EURO_COUNTRY_SET } from '@lemon8/web-app-shared/i18n';
import { atom } from 'jotai';

export const $EnablePintrk = atom((get) => {
  const { region, ipRegion } = get($Locale);
  const { enterHref: href } = get($RootTraffic);

  const { searchParams } = new URL(href);

  return ['US_pinterest', 'JP_pinterest'].includes(searchParams.get('pid') || '') && !EURO_COUNTRY_SET.has(ipRegion);
});
